import type { utils } from 'blockly/core';

import { buildAdvancedToolbox } from './toolboxes/advanced.js';
import { buildBeginnerToolbox } from './toolboxes/beginner.js';
import type { ToolboxOperationMode } from './toolboxes/constants.js';

export {
  ADDON_CATEGORY_CATALOG,
  getAddonCategoryDefinition,
  type AddonCategoryDefinition,
} from './addonCategories.js';
export { categoryCssConfig, categorySubCssConfig, type CategoryIconId } from './categoryCssConfig.js';
export { buildAdvancedToolbox } from './toolboxes/advanced.js';
export { buildBeginnerToolbox } from './toolboxes/beginner.js';
export type { ToolboxOperationMode } from './toolboxes/constants.js';

type ToolboxDefinition = utils.toolbox.ToolboxDefinition;

/** @deprecated Use buildToolboxForBoard with an explicit mode instead. */
export function buildToolbox(): utils.toolbox.ToolboxInfo {
  return buildAdvancedToolbox();
}

/**
 * Build the Blockly toolbox for the active board and operation mode.
 * Switching modes updates the toolbox only — workspace blocks are unchanged.
 */
export function buildToolboxForBoard(
  boardId: string,
  enabledAddonIds: readonly string[] = [],
  mode: ToolboxOperationMode = 'advanced',
): ToolboxDefinition {
  if (mode === 'beginner') {
    return buildBeginnerToolbox(boardId);
  }

  return buildAdvancedToolbox(enabledAddonIds);
}
